import { GAMIFICATION_ROUTES } from "./gamificationRoutes";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { getGamificationBattleClient } from "./gamificationBattleClient";
import "./JoinBattleCode.css";

const JoinBattleCode = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isInitialized, user } = useAuth();
  const client = useMemo(() => getGamificationBattleClient(), []);
  const location = useLocation();
  const invitedCode = new URLSearchParams(location.search).get("roomCode") || "";
  const [roomCode, setRoomCode] = useState(invitedCode);
  const [isConnecting, setIsConnecting] = useState(false);
  const openedRoomRef = useRef(0);
  const joinRequestedRef = useRef(false);
  const [state, setState] = useState(() => client.state);
  const [joinAttempted, setJoinAttempted] = useState(false);

  useEffect(() => client.subscribe(setState), [client]);

  useEffect(() => {
    if (invitedCode) setRoomCode(invitedCode);
  }, [invitedCode]);

  useEffect(() => {
    if (!joinRequestedRef.current || state?.liveStage !== "private_room" || state?.lastSocketAction !== "joinRoom" ||
        !state?.battle_room_id || openedRoomRef.current === state.battle_room_id) return;
    openedRoomRef.current = state.battle_room_id;
    setRoomCode("");
    navigate(Number(state.battles_id) === 1 ? GAMIFICATION_ROUTES.groupWaiting : GAMIFICATION_ROUTES.singleWaiting, { state });
  }, [navigate, state]);

  const handleJoin = async () => {
    const code = roomCode.trim();
    if (!code || isConnecting || client.state?.room_request_pending) return;
    setJoinAttempted(true);
    if (!isInitialized || !isAuthenticated || !Number(user?.user_id || user?.id || 0)) return;
    setIsConnecting(true);
    try {
      const connected = client.state?.isSocketConnected || await client.connect(Number(user?.user_id || user?.id));
      if (connected) joinRequestedRef.current = client.joinRoom({ room_code: code, includeContext: false });
    } finally {
      setIsConnecting(false);
    }
  };

  const busy = isConnecting || Boolean(joinRequestedRef.current && state?.room_request_pending);
  const joinError = !isInitialized || !isAuthenticated || !Number(user?.user_id || user?.id || 0)
    ? "Sign in to join a battle."
    : state?.socketError;

  return (
    <div className="join-battle-card">
      <div className="join-battle-content">
        <h2>Enter Room Code to Join Battle</h2>
        <p>Join an existing battle using your room code.</p>
        <div className="join-battle-form">
          <div className="room-code-input">
            <i className="bi bi-key-fill" aria-hidden="true" />
            <input type="text" inputMode="numeric" placeholder="Enter Room Code" aria-label="Room Code"
              value={roomCode} onChange={(event) => setRoomCode(event.target.value)}
              onKeyDown={(event) => { if (event.key === "Enter") { event.preventDefault(); handleJoin(); } }} />
          </div>
          <button type="button" className="join-battle-btn" onClick={handleJoin} disabled={busy || !roomCode.trim()}>
            {isConnecting ? "Connecting..." : busy ? "Joining..." : "Join"}
          </button>
        </div>
        {joinAttempted && joinError ? <p className="join-battle-error" role="alert">{joinError}</p> : null}
      </div>
    </div>
  );
};

export default JoinBattleCode;
